import { parseCookies } from "nookies";
import {
  DEFAULT_CALENDLY_LINK,
  KOREAN_CALENDLY_LINK,
  OTHER_COUNTRIES_CALENDLY_LINK,
  UCE_CALENDLY_LINK,
  US_CALENDLY_LINK,
} from "../constants/calendly.constants";
import { ROOT_HOST } from "../constants/env/internalService.constants";
import { isBrowser } from "./dom";
import { getProtocol } from "./url.util";
import { allowedUTMParamsList, getUTMFieldsFromLocalStorage, stringifyUTMParams } from "./utm.util";

interface ScheduleDemoLinkProps {
  email?: string | null;
  number?: string | null;
  source?: string;
  extraUtmFields?: { [key: string]: string };
}

export const scheduleDemoLink = ({
  email = null,
  number = null,
  source = "",
  extraUtmFields = {},
}: ScheduleDemoLinkProps) => {
  let utmFields = getUTMFieldsFromLocalStorage();

  Object.entries(extraUtmFields).forEach(
    ([utmFieldKey, utmFieldValue]) => (utmFields[utmFieldKey] = utmFieldValue)
  );
  // utmFields["utm_medium"] = "riseplan";

  const cookies = parseCookies();
  // const hubspotLink = getHubspotLink(utmFields.utm_source);
  const meetingLink = getCalendlyLink(cookies.countryCode);
  if (isBrowser) {
    if (email || number) {
      window
        ?.open(`${meetingLink}?email=${email}&phone_number=${number}`, "_blank")
        ?.focus();
    } else if (isBrowser) {
      const params = new URLSearchParams(window?.location.search);
      const allowedUTMParamsListNew = [...allowedUTMParamsList, 'q', 'gclid']
      allowedUTMParamsListNew.forEach(key => {
        if (params.has(key)) {
          params.delete(key);
        }
      });

      const utmParams = stringifyUTMParams(utmFields);
      const queryString = params.toString();
      
      window
        ?.open(
          `${meetingLink}${queryString.length > 0 ? `?${queryString}&` : "?"}${
            cookies.countryCode !== "KR" ? utmParams : "" // added this for removing utm params for KR ✅
          }`,
          "_blank"
        )
        ?.focus();
    }
    const currentUrl = window?.location.href;
    // sendAmplitudeData("schedule_demo_tapped_landing_page", {
    //   phone_number: number,
    //   email: email ?? "",
    //   source,
    //   UTM_params: utmFields,
    //   current_url: currentUrl,
    // });
    // sendAnalyticsEvent("graphy", GOOGLE_EVENTS.SCHEDULE_DEMO.CTA_CLICKED);
    // sendGoogleTagEvent({
    //   eventName: GOOGLE_EVENTS.SCHEDULE_DEMO.CTA_CLICKED,
    //   gtmId: GTM_ID,
    //   isRootDataLayer: true,
    // });
  }
};

export const openNewTab = (url: string) => {
  if (isBrowser) {
    window.open(url, "_blank");
  }
};

export const getSchoolLink = (subdomain: string, slug = "") =>
  `${getProtocol()}://${subdomain}.${ROOT_HOST}/${slug}`;

export const navigateToSchool = (subdomain: string, slug = "") => {
  window.location.href = `${getSchoolLink(subdomain)}/${slug}`;
};

export const isUceCountryCode = (countryCode: any): boolean => {
  const UCE_COUNTRY_LIST = [
    "US",
    "CA",
    "GB",
    "DE",
    "FR",
    "IT",
    "ES",
    "NL",
    "BE",
    "SE",
    "CH",
    "AT",
    "DK",
    "FI",
    "NO",
    "IE",
    "PT",
    "GR",
    "PL",
    "HU",
    "CZ",
    "RO",
    "BG",
    "SK",
    "HR",
    "RS",
    "SI",
    "LT",
    "LV",
    "EE",
    "CY",
    "LU",
    "MT",
    "IS",
  ];

  return UCE_COUNTRY_LIST.includes(countryCode);
};

export const getCalendlyLink = (countryCode: string): string => {
  if (countryCode === "IN") {
    return DEFAULT_CALENDLY_LINK;
  }
  return US_CALENDLY_LINK;
};
